var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { inject } from 'mobx-react';
import { ViewLarge, ViewSmall, Viewport } from '@shared-ui/viewport-context';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { EGDSLayoutFlex } from '@egds/react-core/layout-flex';
import { getHeaderData } from '../gc-section-data';
import { HeaderMinimalToolbar } from './partners/header-minimal-toolbar';
import { HeaderMinimalTemplateA } from './partners/header-minimal-template-a';
import { HeaderImageToolbar } from '../header-image-toolbar';
import { HeaderNavToolbar } from './partners/header-nav-toolbar';
import { BaseHeader } from './header-elements/base-header';
import { HeaderRegion } from './header-elements/header-region';
import { HeaderLanguagesToolbar } from './partners/header-language-toolbar';
import { ExternalScripts } from './header-elements/external-scripts';
import { HeaderCurrencyToolbar } from './partners/header-currency-toolbar';
import { HeaderCurrencyDisplay } from './partners/header-currency-display';
import { BSABanner } from '../bsa-banner';
import { EGStripe } from '../eg-stripe';
var TemplateA = /** @class */function (_super) {
  __extends(TemplateA, _super);
  function TemplateA() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TemplateA.prototype.render = function () {
    var _a, _b, _c;
    var _d = this.props,
      globalComponentsContext = _d.globalComponentsContext,
      page = _d.page,
      minimal = _d.minimal;
    var headerData = getHeaderData(globalComponentsContext);
    var languages = (_a = globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.header) === null || _a === void 0 ? void 0 : _a.partnerSupportedLanguages;
    var currencies = (_b = globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.header) === null || _b === void 0 ? void 0 : _b.partnerSupportedCurrencies;
    var disabledLOBs = (_c = globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.header) === null || _c === void 0 ? void 0 : _c.disableCurrencyPickerForLOBs;
    var bsa = headerData.bsa;
    var showHeaderCurrencyDisplay = (disabledLOBs === null || disabledLOBs === void 0 ? void 0 : disabledLOBs.length) > 0 && (page === null || page === void 0 ? void 0 : page.navigationId) && disabledLOBs.includes(page.navigationId);
    if (minimal) {
      return React.createElement(React.Fragment, null, React.createElement(EGStripe, null), React.createElement(HeaderMinimalTemplateA, {
        headerData: headerData
      }));
    }
    return React.createElement(React.Fragment, null, React.createElement(EGStripe, null), bsa && React.createElement(BSABanner, {
      bsa: bsa
    }), React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(HeaderMinimalToolbar, {
      headerData: headerData
    })), React.createElement(ViewLarge, null, React.createElement(HeaderRegion, null, React.createElement(EGDSSpacing, {
      padding: {
        inlinestart: 'six',
        inlineend: 'two'
      }
    }, React.createElement(BaseHeader, {
      className: "global_navigation__header__default__max_width"
    }, React.createElement(EGDSLayoutFlex, null, React.createElement(HeaderImageToolbar, {
      headerImg: headerData.headerImg
    }), React.createElement("nav", {
      className: "global-nav-header-links__nav",
      "aria-label": "primary navigation"
    }, React.createElement(EGDSLayoutFlex, {
      className: "global-nav-header-links__nav sub-header__nav",
      alignItems: "center"
    }, React.createElement(HeaderNavToolbar, {
      numberOfLinks: 0,
      menuLinks: headerData.navLinks
    })))), React.createElement(EGDSSpacing, {
      padding: {
        inlinestart: 'three'
      }
    }, React.createElement(EGDSLayoutFlex, {
      alignItems: "center"
    }, React.createElement(HeaderLanguagesToolbar, {
      languages: languages
    }), React.createElement(HeaderNavToolbar, {
      numberOfLinks: 0,
      menuLinks: headerData.secondaryNavLinks
    }), showHeaderCurrencyDisplay ? currencies && React.createElement(HeaderCurrencyDisplay, {
      currencies: currencies
    }) : currencies && React.createElement(HeaderCurrencyToolbar, {
      currencies: currencies
    })))))))), React.createElement(ExternalScripts, __assign({}, globalComponentsContext.header)));
  };
  TemplateA = __decorate([inject('globalComponentsContext', 'page')], TemplateA);
  return TemplateA;
}(React.Component);
export { TemplateA };